import React, {useEffect, useState} from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    IconButton,
    Input,
    Typography
} from "@material-tailwind/react";
import {XMarkIcon} from "@heroicons/react/24/outline";
import {MagnifyingGlassIcon} from "@heroicons/react/24/solid";
import {NumericFormat} from "react-number-format";

const Blocks = () => {
    const [blocks, setBlocks] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        fetchBlocks();
    }, []);

    const fetchBlocks = async () => {
        fetch("/blocks.json")
            .then((response) => response.json())
            .then((data) => setBlocks(data))
            .catch((error) => console.error("Error fetching blocks:", error));
    }

    const handleSearch = async () => {
        setBlocks([]);
        fetch(`/blocks/search.json?query=${searchQuery}`)
            .then((response) => response.json())
            .then((data) => setBlocks(data))
            .catch((error) => console.error("Error fetching blocks:", error));
    }

    const resetSearch = () => {
        setSearchQuery('');
        fetchBlocks();
    }

    return (
        <>
            <div className="mt-12">
                <div className="mb-4 grid grid-cols-1 gap-6 xl:grid-cols-1">
                    <Card className="overflow-hidden xl:col-span-2 border border-blue-gray-100 shadow-sm">
                        <CardHeader
                            floated={false}
                            shadow={false}
                            color="transparent"
                            className="m-0 flex items-center justify-between p-6"
                        >
                            <div className="w-full">
                                <Typography variant="h6" color="blue-gray" className="mb-1">
                                    Manzanas
                                </Typography>
                                <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-end">
                                    {searchQuery &&
                                        <IconButton
                                            variant="text"
                                            className="rounded-full"
                                            onClick={resetSearch}
                                            title='Borrar filtro'
                                        >
                                            <XMarkIcon className='h-4 w-4'/>
                                        </IconButton>
                                    }
                                    <div className='w-full md:w-72'>
                                        <Input
                                            label="Buscar manzana"
                                            icon={<MagnifyingGlassIcon className="h-5 w-5"/>}
                                            onChange={(e) => setSearchQuery(e.target.value.toUpperCase())}
                                            className={'uppercase'}
                                            value={searchQuery}
                                        />
                                    </div>
                                    <Button className="w-full md:w-auto" onClick={handleSearch}>
                                        Buscar
                                    </Button>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody className="px-0 pt-0 pb-2">
                            <div className="overflow-x-auto">
                            <table className="w-full min-w-[640px] table-auto">
                                <thead>
                                <tr>
                                    {["Manzana", "Sector", "Zona", "Tipo", "Descripción", "Precio m2"].map(
                                        (el) => (
                                            <th
                                                key={el}
                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                            >
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                >
                                                    {el}
                                                </Typography>
                                            </th>
                                        )
                                    )}
                                </tr>
                                </thead>
                                <tbody>
                                {blocks.length > 0 ? (
                                    blocks.map((block, key) => {
                                        const className = `py-3 px-5 ${
                                            key === blocks.length - 1 ? "" : "border-b border-blue-gray-50"
                                        }`;

                                        return (
                                            <tr key={block.id} className={`cursor-pointer hover:bg-gray-50`}>
                                                <td className={className}>
                                                    <div className="flex items-center gap-4">
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            {block.block_name}
                                                        </Typography>
                                                    </div>
                                                </td>
                                                <td className={className}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-xs font-medium text-blue-gray-600"
                                                    >
                                                        {block.sector_name}
                                                    </Typography>
                                                </td>
                                                <td className={className}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-xs font-medium text-blue-gray-600"
                                                    >
                                                        {block.zone_name}
                                                    </Typography>
                                                </td>
                                                <td className={className}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-xs font-medium text-blue-gray-600"
                                                    >
                                                        {block.location_type_id}
                                                    </Typography>
                                                </td>
                                                <td className={className}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-xs font-medium text-blue-gray-600"
                                                    >
                                                        {block.description}
                                                    </Typography>
                                                </td>
                                                <td className={className}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-xs font-medium text-blue-gray-600"
                                                    >
                                                        <NumericFormat
                                                            value={block.land_value_per_m2}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            allowLeadingZeros
                                                            thousandSeparator=","
                                                        />
                                                    </Typography>
                                                </td>

                                            </tr>
                                        )
                                    })) : (
                                    <tr>
                                        <td colSpan='8' className='text-center'>
                                            <div
                                                className="flex justify-center items-center text-gray-500 rounded-md py-4">
                                                No se encotraron registros.
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </>
    )
};

export default Blocks;
